import React from "react";
import "./index.css";

const Preloader = () => {
  return (
    <div className="">
      <div className="loader__element" />
    </div>
  );
};

export default Preloader;
